import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12cd7a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "pricing",
  class: "py-5 text-center"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Preisgestaltung", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Egal ob du lieber pro Abfrage oder pro Monat bezahlen möchtest. Bei uns ist beides möglich. Die ersten 14 Tage sind in beiden Plänen kostenlos! ", -1))
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "card mb-4 h-100" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "card-text price" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border" }, null, -1))
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-12cd7a44><div class=\"col-4\" data-v-12cd7a44></div><div class=\"col-4\" data-v-12cd7a44><a href=\"login\" data-v-12cd7a44><button class=\"mt-5 btn btn-primary btn-lg\" data-v-12cd7a44> Jetzt kostenlos testen </button></a></div><div class=\"col-4\" data-v-12cd7a44></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pricingPlans, (plan) => {
          return (_openBlock(), _createElementBlock("div", {
            key: plan.title,
            class: "col-12 col-sm-6 col-md-4 col-lg-3"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, _toDisplayString(plan.title), 1),
                _createElementVNode("p", _hoisted_9, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'euro-sign'] }),
                  _createTextVNode(" " + _toDisplayString(plan.price), 1)
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(plan.subtitle), 1),
                _hoisted_11,
                _createElementVNode("button", {
                  disabled: !plan.active,
                  class: "btn btn-primary",
                  onClick: ($event: any) => ($options.CheckIfUserIsLoggedIn(plan))
                }, _toDisplayString(plan.button), 9, _hoisted_12)
              ])
            ])
          ]))
        }), 128))
      ]),
      _hoisted_13
    ])
  ]))
}